export const name = 'ukeybox-api-config'
const prefix = '/api/v2/agent'
export const api = {
  ukeyBox: {
    getValidDevice: `${prefix}/isv/box/valid-device`, // get 盒子是否插盘
    getUserExist: `/api/v2/bud/user/exist`, // get 检测新老用户
    addUser: '/api/v2/bud/user/register', // post 新增用户
    getValidPerm: `${prefix}/isv/box/valid-perm`, // get 是否有权限
    setBoxBind: `${prefix}/isv/box/bind`, // post 绑定或更换
    setBindRemove: `${prefix}/isv/box/bind-remove`, // get 解除绑定
    getBoxInfo: `${prefix}/isv/box/device-info`, // get 查询盘信息
    useAccountLogin: `/api/v2/bud/login`,
    sendCheckCode: `/api/v2/bud/send-login-code` // get
    // getCheckCode: `/api/v2/bud/send-code`, // post
    // getCode: `/bud/api/v2/bud/check-code`, // post
  }
}
